import { render } from "./LandingPage.vue?vue&type=template&id=643fd5aa"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/LandingPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "643fd5aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('643fd5aa', __exports__)) {
    api.reload('643fd5aa', __exports__)
  }
  
  module.hot.accept("./LandingPage.vue?vue&type=template&id=643fd5aa", () => {
    api.rerender('643fd5aa', render)
  })

}


export default __exports__